import { WagmiPlugin, createConfig } from '@wagmi/vue'
import { mainnet, sepolia, polygon, polygonAmoy, arbitrumSepolia } from 'viem/chains'
import { coinbaseWallet, injected, walletConnect } from '@wagmi/connectors'
import { http } from 'viem'
import { VueQueryPlugin } from '@tanstack/vue-query'

const config = createConfig({
  chains: [mainnet, sepolia, polygon, polygonAmoy, arbitrumSepolia],
  connectors: [
    injected(),
    walletConnect({
      projectId: '',
    }),
    coinbaseWallet({
      appName: 'GameFi',
    }),
  ],
  transports: {
    [mainnet.id]: http(),
    [sepolia.id]: http(),
    [polygon.id]: http(),
    [polygonAmoy.id]: http(),
    [arbitrumSepolia.id]: http(),
  },
})

export default defineNuxtPlugin({
  name: 'wagmi',
  setup(app) {
    app.vueApp.use(VueQueryPlugin)
    app.vueApp.use(WagmiPlugin, { config })
  },
})
